import { DatePipe } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { MovimentoEstoqueService } from 'almoxarifado-lib';
import { PlanoContaService } from 'contabil-lib';
import { BaseResourceRptComponent, Coluna, EddyAutoComplete, FuncaoService, GlobalService, LoginContabil, PlanoConta, SaldoEstoqueService, Setor, SetorService } from 'eddydata-lib';
import { takeUntil } from 'rxjs/operators';
import toastr from 'toastr';

declare var $: any;

@Component({
  selector: 'app-itens-movimentados-rpt',
  templateUrl: './itens-movimentados-rpt.component.html'
})
export class RelatorioItensMovimentadosRptComponent extends BaseResourceRptComponent {

  @Input() visualizar: boolean = false;
  @Output() visualizarChange: EventEmitter<boolean> = new EventEmitter();

  public login: LoginContabil;
  protected datepipe: DatePipe;

  public data_inicial: Date;
  public data_final: Date;

  public geral: boolean = false;
  public geralEstoques: boolean = false;

  public entrada: boolean = true;

  public setor: Setor;
  public setorAutoComplete: EddyAutoComplete<Setor>;

  public planoConta: PlanoConta;
  public planoContaAutoComplete: EddyAutoComplete<PlanoConta>;
  public filtrarContaContabil: boolean = false;
  public utilizarGrupoSubgrupo: boolean = false;
  public tipoContaContabil: 'T' | 'E' = 'T';


  constructor(protected funcaoService: FuncaoService,
    protected globalService: GlobalService,
    protected saldoService: SaldoEstoqueService,
    private movimentoService: MovimentoEstoqueService,
    private setorService: SetorService,
    private planoContaService: PlanoContaService) {
    super();
    this.datepipe = new DatePipe('pt');
    this.login = GlobalService.obterSessaoLogin();
  }

  protected afterInit(): void {
    this.orientacao = 'landscape';
    this.carregarAutoCompletes();
  }

  protected carregarLista(): Promise<any[]> {
    if (!this.validar()) {
      return;
    }

    return new Promise((resolve) => {
      this.movimentoService.itemMovimentadoRpt(
        this.login.orgao.id,
        new FuncaoService().converteDataSQL(this.data_inicial),
        new FuncaoService().converteDataSQL(this.data_final),
        this.entrada,
        this.geralEstoques ? 'S' : 'N',
        this.geral ? 'S' : 'N',
        this.login.setorAlmoxarifado.estoque.id,
        this.setor ? this.setor.id : 0,
        !this.geral && !this.setor ? this.login.setorAlmoxarifado.id : 0,
        this.tipoContaContabil,
        this.planoConta ? this.planoConta.codigo : '',
        this.utilizarGrupoSubgrupo,
      ).pipe(takeUntil(this.unsubscribe))
        .subscribe(lista => resolve(lista.map(item => ({
          ...item,
          especie_nome: this.globalService.tituloEspecieAlmoxarifado(item.especie)
        }))), error => toastr.error(this.funcaoService.obterMensagemErro(error)));
    });
  }

  protected tituloRelatorio(): string {
    const tipoMovimento = this.entrada ? 'ENTRADAS' : 'SAIDAS';
    const periodoInicio = this.data_inicial.toLocaleDateString('pt-BR');
    const periodoFinal = this.data_final.toLocaleDateString('pt-BR');
    return `RELATORIO DE ITENS MOVIMENTADOS POR DESPESA - ${tipoMovimento}\n   Periodo: ${periodoInicio} - ${periodoFinal}`;
  }

  protected subTituloRelatorio(): string {
    const filtros: string[] = [];

    return filtros.join('  -  ');
  }

  protected obterColunasRelatorio(): Coluna[] {
    if (this.utilizarGrupoSubgrupo) {
      return [
        { titulo: 'PLANO CONTA', coluna: 'plano_grupo', alignment: 'left', agrupar: true, bold: true, adicionaisBody: { border: [false, false, false, false] } },
        { titulo: 'DATA', coluna: 'data_movimento', alignment: 'center' },
        { titulo: 'DOCUMENTO', coluna: 'documento', alignment: 'center' },
        { titulo: 'ESPECIE', coluna: 'especie_nome', alignment: 'center' },
        { titulo: 'CÓDIGO', coluna: 'codigo' },
        { titulo: 'PRODUTO', coluna: 'produto' },
        { titulo: 'UNIDADE', coluna: 'unidade' },
        { titulo: 'ESTOQUE/SETOR', coluna: 'estoque_setor' },
        { titulo: 'SUBGRUPO', coluna: 'subgrupo' },
        { titulo: 'QTDE', coluna: 'quantidade', alignment: 'right', decimais: 4 },
        { titulo: 'VALOR UN.', coluna: 'valor_unitario', alignment: 'right', decimais: 2 },
        { titulo: 'TOTAL', coluna: 'valor_total', alignment: 'right', decimais: 2 }
      ];
    } else {
      return [
        { titulo: 'PLANO CONTA', coluna: 'plano_sub', alignment: 'left', agrupar: true, bold: true, adicionaisBody: { border: [false, false, false, false] } },
        { titulo: 'DATA', coluna: 'data_movimento', alignment: 'center' },
        { titulo: 'DOCUMENTO', coluna: 'documento', alignment: 'center' },
        { titulo: 'ESPECIE', coluna: 'especie_nome', alignment: 'center' },
        { titulo: 'CÓDIGO', coluna: 'codigo' },
        { titulo: 'PRODUTO', coluna: 'produto' },
        { titulo: 'UNIDADE', coluna: 'unidade' },
        { titulo: 'ESTOQUE/SETOR', coluna: 'estoque_setor' },
        { titulo: 'SUBGRUPO', coluna: 'subgrupo' },
        { titulo: 'QTDE', coluna: 'quantidade', alignment: 'right', decimais: 4 },
        { titulo: 'VALOR UN.', coluna: 'valor_unitario', alignment: 'right', decimais: 2 },
        { titulo: 'TOTAL', coluna: 'valor_total', alignment: 'right', decimais: 2 }
      ];
    }
  }

  protected larguraColunas(): (string | number)[] {
    return ['auto', 50, 50, 'auto', '*', 'auto', 'auto', '*', 'auto','auto','auto'];
  }

  protected totalizarColunas(): (string | {})[] {
    return [{ nome: 'quantidade', abaixo: true }, { nome: 'valor_total', abaixo: true }];
  }

  protected layout(): {} {
    return {
      padrao: {
        hLineWidth(i, node) {
          return 1;
        },
        vLineWidth(i) {
          return 1;
        },
        hLineColor(i) {
          return 'black';
        },
        paddingLeft(i) {
          return 3;
        },
        paddingRight(i, node) {
          return 3;
        }
      }
    };
  }

  protected conteudoAdicional(lista): {}[] {
    const conteudo: any[] = [];

    conteudo.push([{ text: 'VALOR POR ESPECIE', colSpan: 2, alignment: 'center', bold: true, fontSize: 13 }, { text: '' }]);

    const especies: { descricao: string, valor: number }[] = [];
    let valor_total = 0;

    for (const movimento of lista) {
      const especie = especies.find((e) => e.descricao === movimento.especie);
      if (especie) {
        especie.valor += +movimento.valor_total;
      } else {
        especies.push({ descricao: movimento.especie, valor: +movimento.valor_total });
      }
      valor_total += +movimento.valor_total;
    }

    for (const especie of especies) {
      if (conteudo.length === 1) {
        conteudo.push([{
          text: [
            { text: this.globalService.tituloEspecieAlmoxarifado(<any>especie.descricao) + '  ', bold: true, fontSize: 13, alignment: 'center' }, { text: new FuncaoService().convertToBrNumber(especie.valor), fontSize: 12 }
          ]
        }, {
          text: [
            { text: 'TOTAL  ', bold: true, fontSize: 12, alignment: 'center' }, { text: new FuncaoService().convertToBrNumber(valor_total), fontSize: 12, margin: [10, 0] }
          ], rowSpan: especies.length
        }]);
      } else {
        conteudo.push([{
          text: [
            { text: this.globalService.tituloEspecieAlmoxarifado(<any>especie.descricao) + '  ', bold: true, fontSize: 12, alignment: 'center' }, { text: new FuncaoService().convertToBrNumber(especie.valor), fontSize: 12, margin: [10, 0] }
          ]
        }, { text: '' }]);
      }
    }

    return [{
      alignment: 'justify',
      columns: [{
        layout: 'linhas',
        table: {
          headerRows: 1,
          dontBreakRows: true,
          keepWithHeaderRows: 1,
          widths: ['*', '*'],
          body: conteudo
        }
      }, { text: '' }]
    }];
  }

  protected mensagemVazio(): string {
    return 'Nenhum item movimentado encontrado para os filtros informados.';
  }

  @HostListener('window:keydown.control.p', ['$event'])
  public abrirConsultaProduto(event: KeyboardEvent) {
    event.preventDefault();
    $('#dialogProdutoUnBuscaRelatorioItensMovimentados').modal('show');
  }


  public onHide() {
    this.visualizar = false;
    this.visualizarChange.emit(this.visualizar);
  }

  public show() {
    this.visualizar = true;
    this.visualizarChange.emit(this.visualizar);
  }

  public onChangeTipoContaContabil() {
    if (this.tipoContaContabil !== 'E') {
      this.planoConta = null;
    }
  }


  private carregarAutoCompletes() {
    this.setorAutoComplete = new EddyAutoComplete(null, this.setorService,
      'id', ['codigo', 'nome'], { orgao_id: this.login.orgao.id, relations: 'orgao', orderBy: 'nome' }, { text: ['nome', 'codigo'] }
    );

    this.planoContaAutoComplete = new EddyAutoComplete(null, this.planoContaService,
      'id', ['codigo', 'nome'], { 'exercicio.id': this.login.exercicio.id, orderBy: 'codigo' }, { number: ['codigo'], text: ['nome'] }
    );

  }

  private validar(): boolean {
    if (!this.data_final || !this.data_inicial) {
      toastr.warning('Informe o periodo do relatorio!');
      return false;
    }

    return true;
  }

}
